module.exports = __webpack_public_path__ + "static/media/FSFHorizontalLogo.05a78e8f.svg";